/**
 * Filtering logic for the "_" placeholder suggestion popup, shared with (and mirroring)
 * HtmlEditorPlaceholderMenu.vue's own filtering so both surfaces offer the same tokens.
 */
import Fuse from "fuse.js";
import { getAllTemplateTokens, getTemplateTokenLabel } from "@/lib/utility/template-token-catalog";

export interface PlaceholderSuggestionItem {
  token: string;
  value: string;
  label: string;
}

function getResolvedTokens(resolveToken: (token: string) => unknown): PlaceholderSuggestionItem[] {
  const items: PlaceholderSuggestionItem[] = [];
  for (const token of getAllTemplateTokens()) {
    const value = resolveToken(token);
    const isSimpleValue = typeof value === "string" || typeof value === "number";
    if (isSimpleValue && value !== "") {
      items.push({ token, value: String(value), label: getTemplateTokenLabel(token) });
    }
  }
  return items;
}

export function getPlaceholderSuggestionItems(
  query: string,
  resolveToken: (token: string) => unknown
): PlaceholderSuggestionItem[] {
  const allTokens = getResolvedTokens(resolveToken);
  if (!query) return allTokens;

  const fuse = new Fuse(allTokens, { threshold: 0.4, keys: ["token", "value", "label"] });
  return fuse.search(query).map((result) => result.item);
}
